<form [formGroup]="settingsForm" class="grid grid-nogutter">
  <div class="col-6 flex flex-column gap-2">
    <div class="flex flex-column gap-2">
      <osp-form-field>
        <osp-label [tooltip]="'modules.notification.alarmRuleAddEdit.expl.trackerBatteryStatus' | translate"
          >{{ "modules.notification.alarmRuleAddEdit.labels.trackerBatteryStatus" | translate }}</osp-label
        >
        <osp-dropdown
          [formControlName]="controlNames.SETTINGS_TELEMATICS_BATTERY_STATUS"
          id="telematic-battery-status"
          [options]="batteryStatuses"
        />
        <osp-error [messages]="{ required: 'shared.validation.requiredField' | translate }" />
      </osp-form-field>
    </div>
  </div>
</form>
